export default {
  state: {
    targetName: '',
    account: {},
    property: {},
    rooms: [],
    session: {},
  },
  mutations: {
    updateYoyakuTargetName: (state: any, value: any) => {
      state.targetName = value || '';
    },
    updateYoyakuAccount: (state: any, value: any) => {
      state.account = value || {};
    },
    updateYoyakuProperty: (state: any, value: any) => {
      state.property = value || {};
    },
    updateYoyakuRooms: (state: any, value: any) => {
      state.rooms = value || [];
    },
    updateYoyakuSession: (state: any, value: any) => {
      state.session = value || {};
    },
  },
};
